import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

// Modal component para términos, política y FAQ
const FooterModal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden transform transition-all">
        <div className="flex items-center justify-between p-6 border-b border-border bg-gradient-to-r from-blue-600 to-purple-600">
          <h2 className="text-2xl font-heading font-bold text-white">{title}</h2>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-300 transition-colors p-1 rounded-full hover:bg-white hover:bg-opacity-20"
          >
            <Icon name="X" size={24} />
          </button>
        </div>
        <div className="overflow-y-auto max-h-[calc(90vh-80px)] bg-gradient-to-b from-gray-50 to-white">
          <div className="p-6 text-gray-800 font-body leading-relaxed">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

const FooterSection = () => {
  const currentYear = new Date()?.getFullYear();
  const [modalContent, setModalContent] = useState({ isOpen: false, title: '', content: null });

  const footerData = {
    company: {
      name: "Áurea Fortuna",
      description: "La lotería premium más confiable de Venezuela. Transparencia, seguridad y premios que cambian vidas.",
      logo: "ÁF"
    },
    social: [
      { 
        name: "Facebook", 
        icon: "Facebook", 
        url: "https://www.facebook.com/profile.php?id=100010667526034" 
      },
      { 
        name: "Instagram", 
        icon: "Instagram", 
        url: "https://www.instagram.com/heimerchegarayh?igsh=bXJxb3Rkc2hqandz",
        handle: "@heimerchegarayh"
      }
    ],
    quickLinks: [
      { label: "Inicio", path: "/home-landing" },
      { label: "Comprar Boletos", path: "/purchase-flow" },
      { label: "Verificar Boletos", path: "/ticket-verification" },
      { 
        label: "Contactar Soporte", 
        action: () => window.open('https://wa.me/584122697055?text=Hola, necesito información sobre Áurea Fortuna', '_blank'),
        isExternal: true,
        icon: "MessageCircle"
      }
    ],
    legal: [
      { 
        label: "Términos y Condiciones", 
        action: () => setModalContent({ 
          isOpen: true, 
          title: "Términos y Condiciones de Servicio", 
          content: (
            <div className="space-y-6">
              <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
                <p className="text-sm text-blue-800"><strong>Fecha de Última Actualización:</strong> 9 de Noviembre de 2025</p>
              </div>
              
              <div>
                <p className="mb-4">Aura Fortuna proporciona sus servicios de sorteos y rifas en línea sujeto a la aceptación incondicional de los siguientes Términos y Condiciones. La participación en cualquier sorteo implica la aceptación total de este documento.</p>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <Icon name="FileText" size={18} className="mr-2 text-blue-600" />
                  1. Objeto y Aceptación
                </h3>
                <p className="mb-4">Los presentes Términos regulan la participación de los usuarios en los sorteos organizados por La Empresa y el uso de la plataforma web.</p>
                <p className="mb-4">Al acceder, utilizar o participar en los Servicios, El Participante declara haber leído, entendido y aceptado incondicionalmente estos Términos.</p>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <Icon name="Users" size={18} className="mr-2 text-blue-600" />
                  2. Elegibilidad y Capacidad de Participación
                </h3>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Solo personas mayores de 18 años con capacidad legal para contratar</li>
                  <li>El Participante debe cumplir con las leyes de su país de residencia</li>
                  <li>La Empresa se reserva el derecho de rechazar participación que no cumpla requisitos</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <Icon name="Shuffle" size={18} className="mr-2 text-blue-600" />
                  3. Mecánica del Sorteo
                </h3>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Los boletos se asignan de manera aleatoria y definitiva</li>
                  <li>Compra mínima puede ser establecida por sorteo</li>
                  <li>No hay reembolsos una vez procesado el pago</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <Icon name="Gift" size={18} className="mr-2 text-blue-600" />
                  4. Premios y Reclamo
                </h3>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Premios deben ser retirados en persona</li>
                  <li>Plazo de reclamo: 72 horas desde publicación de resultados</li>
                  <li>Costos y impuestos de traslado son responsabilidad del ganador</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <Icon name="Shield" size={18} className="mr-2 text-blue-600" />
                  5. Limitación de Responsabilidad
                </h3>
                <p className="mb-4">La Empresa no será responsable por daños directos, indirectos, incidentales o consecuenciales derivados del uso de los Servicios.</p>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <Icon name="Scale" size={18} className="mr-2 text-blue-600" />
                  6. Ley Aplicable
                </h3>
                <p>Estos Términos se rigen por las leyes de la República Bolivariana de Venezuela.</p>
              </div>
            </div>
          )
        }) 
      },
      { 
        label: "Política de Privacidad", 
        action: () => setModalContent({ 
          isOpen: true, 
          title: "Política de Uso y Servicio", 
          content: (
            <div className="space-y-6">
              <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-500">
                <p className="text-sm text-green-800"><strong>Fecha de Vigencia:</strong> 9 de Noviembre de 2025</p>
              </div>
              
              <div>
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <Icon name="Wifi" size={18} className="mr-2 text-green-600" />
                  1. Disponibilidad del Servicio
                </h3>
                <p className="mb-4">Los Servicios son proporcionados "tal cual" y "según disponibilidad". El Participante acepta que la plataforma puede experimentar interrupciones sin previo aviso.</p>
                <p className="mb-4">Aura Fortuna no ofrece garantía de continuidad, idoneidad para un fin particular, ausencia de errores o invulnerabilidad del sistema.</p>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <Icon name="Copyright" size={18} className="mr-2 text-green-600" />
                  2. Derechos de Propiedad Intelectual
                </h3>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Todo el contenido es propiedad exclusiva de Aura Fortuna</li>
                  <li>Se concede licencia limitada solo para uso personal</li>
                  <li>Queda prohibida la copia, reproducción o uso comercial</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <Icon name="Edit" size={18} className="mr-2 text-green-600" />
                  3. Modificaciones y Terminación
                </h3>
                <p className="mb-4">Aura Fortuna se reserva el derecho de suspender o terminar el acceso a los Servicios en cualquier momento sin necesidad de expresar causa.</p>
                <p className="mb-4">La Empresa puede modificar cualquier aspecto de los Servicios sin responsabilidad alguna ante los Participantes.</p>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <Icon name="XCircle" size={18} className="mr-2 text-green-600" />
                  4. Conducta Prohibida
                </h3>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>No utilizar los Servicios para fines ilícitos</li>
                  <li>Está prohibido manipular o interferir con la mecánica de sorteos</li>
                  <li>Uso de bots, scripts o métodos automatizados está prohibido</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <Icon name="AlertTriangle" size={18} className="mr-2 text-green-600" />
                  5. Indemnización
                </h3>
                <p className="mb-4">El Participante se obliga a defender e indemnizar a Aura Fortuna de cualquier reclamo que surja de su uso del Servicio.</p>
                <p>La responsabilidad total de Aura Fortuna no excederá el monto total de pagos realizados por el Participante durante los últimos 30 días.</p>
              </div>
            </div>
          )
        }) 
      },
      { 
        label: "Preguntas Frecuentes", 
        action: () => setModalContent({ 
          isOpen: true, 
          title: "Preguntas Frecuentes - Áurea Fortuna", 
          content: (
            <div className="space-y-8">
              {/* Header atractivo */}
              <div className="bg-gradient-to-r from-yellow-400 to-orange-500 p-6 rounded-xl text-center text-white">
                <div className="flex items-center justify-center mb-3">
                  <Icon name="HelpCircle" size={32} className="mr-3" />
                  <h2 className="text-2xl font-bold">¿Cómo podemos ayudarte?</h2>
                </div>
                <p className="text-yellow-100">Somos Áurea Fortuna - Tu lotería de confianza en Venezuela</p>
              </div>

              {/* Pregunta 1 */}
              <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                    <Icon name="Settings" size={16} className="text-blue-600" />
                  </div>
                  ¿Cómo trabajamos aquí en Áurea Fortuna?
                </h3>
                <p className="text-gray-700 leading-relaxed">En Áurea Fortuna creemos en la transparencia total. Cada día trabajamos para brindarte la mejor experiencia de sorteo, desde la compra de tu boleto hasta la entrega del premio. Nuestro equipo está disponible 24/7 para apoyarte en todo el proceso.</p>
              </div>

              {/* Pregunta 2 */}
              <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                    <Icon name="Shuffle" size={16} className="text-green-600" />
                  </div>
                  ¿Por qué elegimos a nuestros ganadores de manera aleatoria?
                </h3>
                <p className="text-gray-700 leading-relaxed">La aleatoriedad es nuestra base fundamental. Utilizamos algoritmos certificados que garantizan que todos los participantes tengan exactamente la misma probabilidad de ganar. Esto es lo que nos hace diferentes - la justicia en cada sorteo.</p>
              </div>

              {/* Pregunta 3 */}
              <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                    <Icon name="Shield" size={16} className="text-purple-600" />
                  </div>
                  ¿Cómo verificamos la seguridad de nuestros sorteos?
                </h3>
                <p className="text-gray-700 leading-relaxed">Cada sorteo que realizamos se graba y está disponible para su verificación pública. Además, trabajamos con auditores externos que supervisan nuestros procesos. La confianza de nuestros participantes es nuestro activo más valioso.</p>
              </div>

              {/* Pregunta 4 */}
              <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <div className="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center mr-3">
                    <Icon name="CreditCard" size={16} className="text-indigo-600" />
                  </div>
                  ¿Qué métodos de pago aceptamos?
                </h3>
                <p className="text-gray-700 leading-relaxed">Para tu comodidad, aceptamos Pago Móvil de los principales bancos de Venezuela (Banesco, Mercantil, Venezuela) y Zelle para pagos internacionales. Todos los pagos son verificados personalmente por nuestro equipo antes de asignar los boletos.</p>
              </div>

              {/* Pregunta 5 */}
              <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <div className="w-8 h-8 bg-pink-100 rounded-full flex items-center justify-center mr-3">
                    <Icon name="Phone" size={16} className="text-pink-600" />
                  </div>
                  ¿Cómo contactamos a nuestros ganadores?
                </h3>
                <p className="text-gray-700 leading-relaxed">Una vez publicado el resultado, nuestro equipo se pone en contacto contigo en un plazo máximo de 48 horas por WhatsApp y llamada telefónica. También te enviamos el comprobante del sorteo por email para que tengas todo documentado.</p>
              </div>

              {/* Pregunta 6 */}
              <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center mr-3">
                    <Icon name="Search" size={16} className="text-red-600" />
                  </div>
                  ¿Qué pasa si pierdo mi boleto?
                </h3>
                <p className="text-gray-700 leading-relaxed">No te preocupes, nosotros llevamos un registro digital de todos los boletos vendidos. Solo necesitas tu número de cédula y nosotros verificamos tu participación al instante. También puedes revisar tu historial en nuestro sitio web.</p>
              </div>

              {/* Pregunta 7 */}
              <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-3">
                    <Icon name="RotateCcw" size={16} className="text-orange-600" />
                  </div>
                  ¿Puedo cambiar de opinión después de comprar?
                </h3>
                <p className="text-gray-700 leading-relaxed">Entendemos que a veces las decisiones cambian, pero una vez que se procesa tu pago y se asigna tu boleto número, ya no es posible el reembolso. Esto nos permite mantener la integridad de cada sorteo y asegurar que todos tengan las mismas oportunidades.</p>
              </div>

              {/* Pregunta 8 */}
              <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-lg font-semibold mb-3 text-gray-900 flex items-center">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center mr-3">
                    <Icon name="Star" size={16} className="text-teal-600" />
                  </div>
                  ¿Qué nos hace diferentes de otras loterías?
                </h3>
                <p className="text-gray-700 leading-relaxed">Nuestra diferencia está en el servicio personalizado. No solo vendemos boletos, creamos una comunidad. Conocemos a nuestros participantes por su nombre, estamos disponibles cuando nos necesitas, y celebramos cada ganador como si fuera familia nuestra.</p>
              </div>

              {/* Sección de Soporte Destacada */}
              <div className="bg-gradient-to-r from-blue-50 via-purple-50 to-pink-50 p-8 rounded-2xl border border-blue-200 shadow-lg mt-8">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                    <Icon name="Headphones" size={32} className="text-white" />
                  </div>
                  <h4 className="text-2xl font-bold text-gray-900 mb-2">¿Necesitas ayuda personalizada?</h4>
                  <p className="text-gray-600">Nuestro equipo de soporte está aquí para resolver cualquier duda</p>
                </div>
                
                <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 mb-6">
                  <p className="text-gray-700 mb-4 text-center">
                    Si tienes alguna pregunta específica sobre tus boletos, sorteos, métodos de pago, o necesitas asistencia inmediata, 
                    no dudes en contactarnos. Estamos disponibles para ayudarte con cualquier consulta.
                  </p>
                  
                  <div className="flex flex-col sm:flex-row gap-3 justify-center items-center text-sm text-gray-600">
                    <div className="flex items-center">
                      <Icon name="Clock" size={16} className="mr-2 text-green-500" />
                      <span>Respuesta inmediata</span>
                    </div>
                    <div className="flex items-center">
                      <Icon name="MessageCircle" size={16} className="mr-2 text-blue-500" />
                      <span>Soporte en WhatsApp</span>
                    </div>
                    <div className="flex items-center">
                      <Icon name="Users" size={16} className="mr-2 text-purple-500" />
                      <span>Equipo especializado</span>
                    </div>
                  </div>
                </div>

                <button 
                  onClick={() => window.open('https://wa.me/584122697055?text=Hola, necesito información sobre Áurea Fortuna', '_blank')}
                  className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-300 flex items-center justify-center space-x-3 shadow-lg hover:shadow-xl transform hover:scale-105"
                >
                  <Icon name="MessageCircle" size={24} />
                  <span className="text-lg">Contactar Soporte Ahora</span>
                  <Icon name="ExternalLink" size={18} />
                </button>

                <p className="text-xs text-gray-500 text-center mt-3">
                  Al hacer clic serás redirigido a WhatsApp para chatear con nuestro equipo
                </p>
              </div>
            </div>
          )
        }) 
      }
    ],
    paymentMethods: [
      {
        name: "Pago Móvil",
        icon: "Smartphone",
        description: "Banesco, Mercantil, Venezuela"
      },
      {
        name: "Zelle",
        icon: "DollarSign",
        description: "Pagos internacionales"
      }
    ]
  };

  const closeModal = () => {
    setModalContent({ isOpen: false, title: '', content: null });
  };

  return (
    <footer className="bg-navy text-foreground">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Company Info */}
          <div className="lg:col-span-1 space-y-6">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-br from-secondary to-golden rounded-lg flex items-center justify-center shadow-golden">
                <span className="text-navy font-heading font-bold text-xl">
                  {footerData?.company?.logo}
                </span>
              </div>
              <div>
                <h3 className="text-xl font-heading font-bold text-foreground">
                  {footerData?.company?.name}
                </h3>
                <p className="text-xs text-text-secondary font-caption">
                  Lotería Premium
                </p>
              </div>
            </div>
            
            <p className="text-sm text-text-secondary font-body leading-relaxed">
              {footerData?.company?.description}
            </p>

            {/* Social Media */}
            <div>
              <h4 className="font-body font-semibold text-foreground mb-3">
                Síguenos
              </h4>
              <div className="flex space-x-3">
                {footerData?.social?.map((social) => (
                  <a
                    key={social?.name}
                    href={social?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-muted/20 hover:bg-secondary/20 rounded-lg flex items-center justify-center transition-premium hover:scale-110"
                    aria-label={`Seguir en ${social?.name}`}
                  >
                    <Icon name={social?.icon} size={18} className="text-text-secondary hover:text-secondary" />
                  </a>
                ))}
              </div>
              {footerData?.social?.find(s => s.name === 'Instagram') && (
                <p className="text-xs text-text-secondary font-caption mt-2">
                  @{footerData.social.find(s => s.name === 'Instagram')?.handle}
                </p>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h4 className="font-heading font-bold text-foreground">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-3">
              {footerData?.quickLinks?.map((link, index) => (
                <li key={link?.path || `support-${index}`}>
                  {link?.action ? (
                    <button
                      onClick={link?.action}
                      className="text-sm text-text-secondary hover:text-secondary transition-premium font-body flex items-center space-x-2 group text-left w-full"
                    >
                      <Icon name={link?.icon || "ChevronRight"} size={14} className="group-hover:translate-x-1 transition-premium text-green-500" />
                      <span className="flex-1">{link?.label}</span>
                      {link?.isExternal && (
                        <Icon name="ExternalLink" size={12} className="text-green-500" />
                      )}
                    </button>
                  ) : (
                    <a
                      href={link?.path}
                      className="text-sm text-text-secondary hover:text-secondary transition-premium font-body flex items-center space-x-2 group"
                    >
                      <Icon name="ChevronRight" size={14} className="group-hover:translate-x-1 transition-premium" />
                      <span>{link?.label}</span>
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Support */}
          <div className="space-y-6">
            <h4 className="font-heading font-bold text-foreground">
              Soporte Legal
            </h4>
            <ul className="space-y-3">
              {footerData?.legal?.map((link) => (
                <li key={link?.label}>
                  <button
                    onClick={link?.action}
                    className="text-sm text-text-secondary hover:text-secondary transition-premium font-body flex items-center space-x-2 group text-left w-full"
                  >
                    <Icon name="ChevronRight" size={14} className="group-hover:translate-x-1 transition-premium" />
                    <span>{link?.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Payment Methods */}
          <div className="space-y-6">
            <h4 className="font-heading font-bold text-foreground">
              Métodos de Pago
            </h4>
            <div className="space-y-3">
              {footerData?.paymentMethods?.map((method) => (
                <div key={method?.name} className="flex items-center space-x-3">
                  <Icon name={method?.icon} size={16} className="text-secondary" />
                  <div>
                    <div className="text-sm font-body text-foreground">{method?.name}</div>
                    <div className="text-xs text-text-secondary font-caption">
                      {method?.description}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            
            <div className="flex items-center space-x-4 text-xs text-text-secondary font-caption">
              <span>© {currentYear} Áurea Fortuna. Todos los derechos reservados.</span>
            </div>

            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <Icon name="Shield" size={14} className="text-success" />
                <span className="text-xs text-success font-caption">
                  Sorteo Verificado
                </span>
              </div>
              
              <div className="flex items-center space-x-2">
                <Icon name="Lock" size={14} className="text-secondary" />
                <span className="text-xs text-text-secondary font-caption">
                  Pagos Seguros
                </span>
              </div>
            </div>
          </div>

          {/* Desarrollador */}
          <div className="mt-4 pt-4 border-t border-border text-center">
            <p className="text-xs text-text-secondary font-caption">
              Sitio web desarrollado por Guionstudio: <a href="mailto:guionstudios@gmail.com" className="text-secondary hover:text-secondary/80">guionstudios@gmail.com</a>
            </p>
          </div>
        </div>
      </div>

      {/* Modal para Términos, Política y FAQ */}
      <FooterModal
        isOpen={modalContent.isOpen}
        onClose={closeModal}
        title={modalContent.title}
      >
        {modalContent.content}
      </FooterModal>
    </footer>
  );
};

export default FooterSection;